module.exports = __webpack_public_path__ + "img/Warrior-draenei-m-70.45015505.gif";